import { Injectable } from '@angular/core';
import { ApiService, TeamMember } from '@shared';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedResourcesType } from '@core/shared-resources/shared-resources.model';
import { MojoTeamMemberService } from 'mojo-share-resource';

@Injectable()
export class SharedResourcesApiService extends ApiService<any> implements MojoTeamMemberService {
  private readonly suffixUrl = `team-members`;
  constructor(http: HttpClient) {
    super(http);
  }

  getTeamMembers(
    serviceEndpointPath: SharedResourcesType,
    resourceId: number,
  ): Observable<TeamMember[]> {
    return this.get({ url: `${serviceEndpointPath}/${resourceId}/${this.suffixUrl}` });
  }

  addTeamMembers(
    serviceEndpointPath: string,
    resourceId: number,
    teamMembers: number[],
  ): Observable<any> {
    return this.post({
      url: `${serviceEndpointPath}/${resourceId}/${this.suffixUrl}`,
      body: teamMembers,
    });
  }

  removeTeamMember(
    serviceEndpointPath: string,
    teamMemberId: number,
    resourceId: number,
  ): Observable<any> {
    return this.delete({
      id: teamMemberId,
      url: `${serviceEndpointPath}/${resourceId}/${this.suffixUrl}/`,
    });
  }

  updateTeamMembers(
    serviceEndpointPath: string,
    resourceId: number,
    teamMembers: number[],
  ): Observable<any> {
    return this.put({
      url: `${serviceEndpointPath}/${resourceId}/${this.suffixUrl}/`,
      body: teamMembers,
    });
  }
}
